'use client';

import { merriweather } from '@/app/fonts';
import { SignupForm } from '@/components/signup-form';
import { useState } from 'react';

import { ConfirmSignupEmailOTP } from '@/components/confirm-signup-email-otp';
import { Logo } from '@/components/site-header-nav';
import { AuthHeader } from '@/components/auth/Header';


export default function SignupPage() {
  const [cognitoUsername, setCognitoUsername] = useState('');

  const showOTPInput = (username: string) => {
    setCognitoUsername(username);
  };

  const showStep = () => {
    if (cognitoUsername) {
      return <ConfirmSignupEmailOTP cognitoUsername={cognitoUsername} />;
    }
    return <SignupForm showOTPInput={showOTPInput} />;
  };

  return (
    <div className="min-h-svh">
      <AuthHeader currentPage="signup" />
      <div className="flex flex-col items-center px-10 gap-4 md:p-10 w-full max-w-xl m-auto pt-16">
        <Logo width={500} className="mt-10" showDescription={true} />
        <div
          className={`${merriweather.className} flex -mt-2 flex-col items-center gap-2 text-center mb-2`}
        >
          <h1 className="text-2xl">Create an account</h1>
          <p className="text-muted-foreground text-sm text-balance">
            {cognitoUsername
              ? 'Please enter the verfication code sent to your email'
              : 'Enter your details below to create your account'}
          </p>
        </div>
        {showStep()}
      </div>
    </div>
  );
}
